import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IEvent } from "@Interfaces";

import {
    ACTION_TYPES,
    API_ACTION_TYPES,
    SELECTORS,
    createAction,
} from "@Utils";
import { classNames } from "repoV2/utils/common/render/classNames";
import { CURRENCY_STRINGS } from "repoV2/constants/payment";

import { IDirectDiscount } from "./IDirectDiscount";

import styles from "../../userDetails.module.scss";

const DirectDiscount = ({ eventData }: IDirectDiscount.IProps) => {
    const dispatch = useDispatch();

    const {
        // discountCode,
        discountData, // The data sent by the API. Is null for invalid coupon code
        discountError, // The message to be shown
        discountEntered: discount, // The value entered in the input box
    }: IEvent.IDiscount = useSelector(SELECTORS.discountInfo);

    const setDiscount = (discountProp: string = "") => {
        dispatch(
            createAction(ACTION_TYPES.EVENT.UPDATE_DISCOUNT, {
                discount: discountProp,
            })
        );
    };

    const handleDiscountChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ): void => {
        setDiscount(e.target.value.trim().toUpperCase());
    };

    const handleNormalDiscountSubmit = (
        e: React.MouseEvent<HTMLButtonElement>
    ): void => {
        e.preventDefault();
        if (discount.length === 0) return;
        const selectedOfferingVariation = eventData?.selectedOfferingVariation;
        dispatch(
            createAction(ACTION_TYPES.UTILS.API_CALL, {
                apiActionType: API_ACTION_TYPES.APPLY_DISCOUNT,
                payload: {
                    code: discount.trim().toUpperCase(),
                    listing_uuid: eventData?.uuid,
                    ...(selectedOfferingVariation && {
                        offering_variant_uuid: selectedOfferingVariation.uuid,
                    }),
                    currency: eventData?.currency_name || CURRENCY_STRINGS.INR,
                },
            })
        );
    };

    return (
        <div className={styles.formField}>
            <div className={styles.formTitle}>
                Have a discount code? Apply it here
            </div>
            <div className={styles.fieldContainer}>
                <input
                    type="text"
                    id="userInfo-discount"
                    className={classNames(
                        styles.formInput,
                        styles.discountField,
                        discountError && styles.formInputError,
                        discountData && styles.formInputSuccess
                    )}
                    name="discount"
                    onChange={handleDiscountChange}
                    value={discount}
                    placeholder="Enter Discount Code"
                />
                <button
                    type="button"
                    id="discount-discountApply"
                    disabled={!!(discount.length === 0 || discountError)}
                    className={styles.discountSubmit}
                    onClick={handleNormalDiscountSubmit}
                >
                    Apply
                </button>
            </div>
            <div
                className={classNames(
                    styles.fieldError,
                    discountData && styles.fieldSuccess
                )}
            >
                {(discountData && "Coupon Code Applied!") || discountError || (
                    <>&nbsp;</>
                )}
            </div>
        </div>
    );
};

export default DirectDiscount;
